module.exports = __webpack_public_path__ + "assets/media/style.c23dd832.styl";